import { Dialog } from '@busybusy/webapp-react-ui';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import IPosition from 'types/Position';
import SafetyIncidentForm from '../forms/SafetyIncidentForm';

export interface ISafetyIncidentDetailProps {
  position: IPosition;
  editable: boolean;
  onUpdate: () => Promise<any>;
}

const SafetyIncidentDetail = (props: ISafetyIncidentDetailProps) => {
  const { position, editable, onUpdate } = props;

  const detailOpenable = useOpenable();

  const onSubmitForm = () => {
    detailOpenable.close();
    onUpdate();
  };

  return (
    <>
      <ProDetailsItem
        title={t('Incident Reports')}
        onClick={detailOpenable.open}
        value={position.createIncident ? (position.manageIncident ? t('Manage') : t('Create Only')) : t('Off')}
        hint={t('Create, view, edit, delete, and review all incident reports.')}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={detailOpenable.isOpen} onClose={detailOpenable.close}>
        <SafetyIncidentForm
          onSubmit={onSubmitForm}
          createIncident={position.createIncident ?? false}
          manageIncident={position.manageIncident ?? false}
          positionId={position.id}
        />
      </Dialog>
    </>
  );
};

export default SafetyIncidentDetail;
